export interface IPurchaseLedgerFavoriteRow {
	LedgerCode:string;
	VatPercent:number;
	Comment:string;
}

export interface IPurchaseLedgerFavorite {
	ID:number;
	Name:string;
	Rows:IPurchaseLedgerFavoriteRow[];
}

export class BookkeepingConfig {
	DefaultSaleCentral:string = "400000";
	DefaultPurchaseCentral:string = "440000";
	DefaultSuspenseAccount:string = "499999";
	VATNotSubtractable:string = "640000";
	VATImportWithinEG:string = "498440";
	DefaultSaleLedgerAccountCode:string = "700000"
DefaultPurchaseLedgerAccountCode:string = "600100"
	BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger:boolean = false;
	PurchaseLedgerFavorites:IPurchaseLedgerFavorite[] = [];
	DepreciationJournalID:number = 1;
	DepreciationPeriodicity:string = "month";
	AutoBookDepreciations:boolean = false;
	OpeningBalanceJournalID:number = 1;
	OpeningBalanceProfitLedgerCode:string = "140000";
	OpeningBalanceLossLedgerCode:string = "141000";
	OpeningBalanceSuspenseLedgerCode:string = "499000";
	AutoCreateOpeningBalance:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.DefaultSaleCentral = data.DefaultSaleCentral;
		this.DefaultPurchaseCentral = data.DefaultPurchaseCentral;
		this.DefaultSuspenseAccount = data.DefaultSuspenseAccount ? data.DefaultSuspenseAccount : "499999";
		this.VATNotSubtractable = data.VATNotSubtractable ? data.VATNotSubtractable : "640000";
		this.VATImportWithinEG = data.VATImportWithinEG ? data.VATImportWithinEG : "498440";
		this.DefaultSaleLedgerAccountCode = data.DefaultSaleLedgerAccountCode;
		this.DefaultPurchaseLedgerAccountCode = data.DefaultPurchaseLedgerAccountCode;
		this.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger = data.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger;
		this.PurchaseLedgerFavorites = [...(data.PurchaseLedgerFavorites || [])];
		this.DepreciationJournalID = data.DepreciationJournalID || 1;
		this.DepreciationPeriodicity = data.DepreciationPeriodicity == "year" ? "year" : "month";
		this.AutoBookDepreciations = data.AutoBookDepreciations == true;
		this.OpeningBalanceJournalID = data.OpeningBalanceJournalID || 1;
		this.OpeningBalanceProfitLedgerCode = data.OpeningBalanceProfitLedgerCode || "140000";
		this.OpeningBalanceLossLedgerCode = data.OpeningBalanceLossLedgerCode || "141000";
		this.OpeningBalanceSuspenseLedgerCode = data.OpeningBalanceSuspenseLedgerCode || "499000";
		this.AutoCreateOpeningBalance = data.AutoCreateOpeningBalance == true;
	}

	public getJSON(){
		return {
			DefaultSaleCentral: this.DefaultSaleCentral,
			DefaultPurchaseCentral: this.DefaultPurchaseCentral,
			DefaultSuspenseAccount: this.DefaultSuspenseAccount,
			VATNotSubtractable: this.VATNotSubtractable,
			VATImportWithinEG: this.VATImportWithinEG,
			DefaultSaleLedgerAccountCode: this.DefaultSaleLedgerAccountCode,
			DefaultPurchaseLedgerAccountCode: this.DefaultPurchaseLedgerAccountCode,
			BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger: this.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger,
			PurchaseLedgerFavorites: [...this.PurchaseLedgerFavorites],
			DepreciationJournalID: this.DepreciationJournalID,
			DepreciationPeriodicity: this.DepreciationPeriodicity,
			AutoBookDepreciations: this.AutoBookDepreciations,
			OpeningBalanceJournalID: this.OpeningBalanceJournalID,
			OpeningBalanceProfitLedgerCode: this.OpeningBalanceProfitLedgerCode,
			OpeningBalanceLossLedgerCode: this.OpeningBalanceLossLedgerCode,
			OpeningBalanceSuspenseLedgerCode: this.OpeningBalanceSuspenseLedgerCode,
			AutoCreateOpeningBalance: this.AutoCreateOpeningBalance
		};
	}
}